import BoxArrowRight from './BoxArrowRight'

export default BoxArrowRight
